import ButtonWithIcon from '@/components/common/ButtonWithIcon';
import { FlexRow } from '@/components/common/Flex';
import { Clock, ShieldTick } from '@/components/common/icons';
import { Paragraph, Subheader } from '@/components/common/Typography';
import { useAccountSetupSteps } from '@/components/goals/useAccountSetupSteps';
import { BoxProps, Text } from '@chakra-ui/react';
import { FlexCol } from '../common/Flex';

interface OpenAccountCalloutProps extends BoxProps {
    title: string;
}

const OpenAccountCallout = ({ title, ...props }: OpenAccountCalloutProps) => {
    const { handleNextStep } = useAccountSetupSteps({});

    return (
        <FlexRow
            bg="gray.50"
            border="1px solid"
            borderColor="gray.100"
            borderRadius="lg"
            py={6}
            px={8}
            gap={10}
            align="center"
            justify="space-between"
            {...props}
        >
            <FlexCol gap={2}>
                <Subheader fontSize="md">{title}</Subheader>
                <Paragraph color="textMuted">
                    <Text fontWeight="semibold" as="span">
                        <Clock mt="-2px" mr="1px" size="sm" /> 3 mins.
                    </Text>{' '}
                    You&apos;ll only have to do this once. We&apos;ll ask a few
                    questions about your preferences and verify your identity.
                    Then, you’ll be able to open goals within your new account.
                </Paragraph>
            </FlexCol>
            <ButtonWithIcon
                size="sm"
                h={11}
                onClickEvent="Open Your Account Button Clicked"
                iconLeft={<ShieldTick />}
                minW={180}
                onClick={() => handleNextStep({})}
            >
                Open your account
            </ButtonWithIcon>
        </FlexRow>
    );
};

export default OpenAccountCallout;
